import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Location } from '@angular/common';
import {Router} from '@angular/router';
import {RoutingTrackerService} from '../../../Services/routing-tracker.service';

@Component({
  selector: 'app-error400-page',
  templateUrl: './error400-page.component.html',
  styleUrls: ['./error400-page.component.css'],
  standalone: false
})
export class Error400PageComponent implements OnInit, AfterViewInit {

  constructor(
    private location: Location,
    private routeTracker: RoutingTrackerService,
    private router: Router
  ) {
  }

  // Used to decide whether to show Back button or Close button when no previous route is available
  hasPrevRoute = false;
  showDetail = false;
  errorCode = '';
  errorFromPage = '';
  errorDateTime = '';
  errorMessage = '';

  ngOnInit(): void {
    const prev = this.routeTracker.getPreviousUrl();
    this.hasPrevRoute = !!(prev && prev.length > 0);
    const state = this.router.getCurrentNavigation()?.extras?.state ?? history.state;
    this.errorCode = state?.errorCode || '';
    this.errorFromPage = state?.errorFromPage || '';
    this.errorDateTime = state?.errorDateTime || '';
    this.errorMessage = state?.errorMessage || '';
  }

  ngAfterViewInit() {

    // console.log(this.routeTracker.getCurrentUrl());

    setTimeout(() => {
      // this._activateMenu();
    });

    // document.body.setAttribute('data-layout-color', leftMenuColor);
  }

  back(): void {
    // Go back 2 steps: step 1 is the faulty URL that caused the 404,
    // step 2 is the page the user was actually on before the error.
    this.location.historyGo(-2);
  }

  // Explicit close handler when this page is the first page opened (no route history)
  close(): void {
    try {
      window.close();
    } catch {
      // ignore
    } finally {
      // If the browser blocks window.close(), send the user to Home as a safe default
      this.router.navigate(['/home']).then();
    }
  }

  home(): void {
    const prevPage = this.routeTracker.getPreviousUrl();
    if (prevPage?.length > 0) {
      // this.router.navigateByUrl('/home').then();
      this.router.navigate(['/home']).then();
    } else {
      // this.router.navigateByUrl('/login').then();
      this.router.navigate(['/login']).then();
    }
  }
}
